import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';
import { DirectivesModule } from '../directives/module';
import { ProductInfoEdit } from './components/edit/component';
import { ProductInfoList } from './components/list/component';
import { ProductInfoApiService } from './services/product-info-api-service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    DragDropModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [ProductInfoList, ProductInfoEdit],
  providers: [
    ProductInfoApiService,
    {
      provide: 'window',
      useFactory: () => window || {},
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [ProductInfoList],
})
export class ProductInfoModule {}
